import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AnexoDelegacion} from "../../../models/AnexoDelegacion";
@Injectable({
  providedIn: 'root'
})
export class CpTallerService
{

  private hostPeticion : string = environment.delegacionesWSBase;
  constructor(private http: HttpClient){}

  public getProvincias(token:string):Promise<string[]>
  {
    let url:string = this.hostPeticion + "/CPTalleres/getProvincias"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<string[]>((resolve, reject) =>
    {
      this.http.get(url,httpOptions)
      .subscribe
      ({
        next(value:any)
        {
          resolve(value);
        },
        error(err){reject(err);}
      });
    });
  }

  public getPoblaciones(token:string,provincia:string):Promise<string[]>
  {
    let url:string = this.hostPeticion + "/CPTalleres/getPoblaciones"

    provincia='"'+provincia.toUpperCase()+'"';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    return new Promise<string[]>((resolve, reject) =>
    {
      this.http.post(url,provincia,httpOptions)
      .subscribe
      ({
        next(value:any)
        {
          resolve(value);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      });
    });
  }

  public getTalleresCp(token:string,cp:string)
  {
    let url:string = this.hostPeticion + "/CPTalleres"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [
              {
                campo: "cp",
                operacion: "=",
                valor: cp
              }
            ]
          ],
        select: ["tall1"]
      };

    return new Promise<any[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(value:any)
          {
            resolve(value);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }


}
